<template>
	<Loader v-if="loading" />
	<div v-else>
		<button v-on:click="load()" class="margin-bottom">Re-load</button>

		<table class="basic">
			<thead>
				<tr>
					<th>SKU</th>
					<th>Woo commerce</th>
					<th>Shop lines</th>
					<th>Products table</th>
					<th>DLV (table)</th>
					<th>WH DLV</th>
					<th>SL Returned</th>
					<th>Return content (table)</th>
					<th>WH return content</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(record, ean) in matrix">
					<td> {{ ean }} <div class="note" v-for="sku in record.skus"> {{ sku }} </div></td>
					<td>{{ typeof record.sources.woocommerce == 'undefined' ? '-' : 'Yes' }}</td>
					<td>{{ typeof record.sources.shop_lines == 'undefined' ? '-' : 'Yes' }}</td>
					<td>{{ typeof record.sources.products_table == 'undefined' ? '-' : 'Yes' }}</td>
					<td>{{ typeof record.sources.dlv == 'undefined' ? '-' : 'Yes' }}</td>
					<td>{{ typeof record.sources.warehouse_dlv == 'undefined' ? '-' : 'Yes' }}</td>
					<td>{{ typeof record.sources.shop_lines_returned == 'undefined' ? '-' : 'Yes' }}</td>
					<td>{{ typeof record.sources.return_content == 'undefined' ? '-' : 'Yes' }}</td>
					<td>{{ typeof record.sources.warehouse_return_content == 'undefined' ? '-' : 'Yes' }}</td>
				</tr>
			</tbody>
		</table>

		<Group title="Suggeted deletions" class="large-margin-top">
			<div class="margin-bottom">
				These products can only be deleted when <strong>DLV has been processed</strong>.
				Delete them from "Rebuild" under "Diagnostics", or from Woocommerce.
			</div>
			<div v-for="product in suggested_deletions">
				{{ product.ID }}
				|
				{{ product.post_title }}
			</div>
			<!-- {{ suggested_deletions }} -->
		</Group>

	</div>
</template>

<script>
import Vue from 'vue'

export default {
  props: [
    'id',
    'autoload'
  ],
  data: () => ({
    loading: false,
    matrix: {},
    suggested_deletions: []
  }),
  methods: {
    load () {
      console.log('/order/' + this.id + '/product-matrix')
      Vue.api.get('/order/' + this.id + '/product-matrix', {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: data => {
          this.matrix = data.matrix
          this.suggested_deletions = data.suggested_deletions
        }
      })
    }
  },
  created () {
    if (this.autoload) {
      this.load()
    }
  }
}
</script>
